/* eslint-disable import/no-default-export */
import { Action, actionCreator, createReducer } from '@trello/redux';

const RAISE_ALERT = Symbol('ui/RAISE_ALERT');
const CANCEL_ALERT = Symbol('ui/CANCEL_ALERT');
const CANCEL_ALL_ALERTS = Symbol('ui/CANCEL_ALL_ALERTS');

export type AlertArea = string;
export type AlertName = string;

interface RaiseAlertPayload {
  alertArea: AlertArea;
  alertName: AlertName;
}

interface CancelAlertPayload {
  alertArea: AlertArea;
}

export interface AlertsState {
  [alertArea: string]: AlertName;
}

type RaiseAlertAction = Action<typeof RAISE_ALERT, RaiseAlertPayload>;
type CancelAlertAction = Action<typeof CANCEL_ALERT, CancelAlertPayload>;
type CancelAlertsAction = Action<typeof CANCEL_ALL_ALERTS, void>;

/**
 * Deprecating in favor of showFlag. If you need to implement a custom alert
 * during this migration, please reach out to @raymond.
 * @deprecated
 */
export const raiseAlert = actionCreator<RaiseAlertAction>(RAISE_ALERT);
export const cancelAlert = actionCreator<CancelAlertAction>(CANCEL_ALERT);
export const cancelAllAlerts = actionCreator<CancelAlertsAction>(
  CANCEL_ALL_ALERTS,
);

const initialState: AlertsState = {};

export default createReducer(initialState, {
  [RAISE_ALERT](
    state,
    { payload: { alertArea, alertName } }: RaiseAlertAction,
  ) {
    const newState = {
      ...state,
      [alertArea]: alertName,
    };

    return newState;
  },

  [CANCEL_ALERT](state, { payload: { alertArea } }: CancelAlertAction) {
    const { [alertArea]: val, ...rest } = state;

    return rest;
  },

  [CANCEL_ALL_ALERTS]() {
    return initialState;
  },
});
